const Component = {
  "图片 url 不存在": "URL ของรูปภาพไม่มีอยู่",
  "暂不支持下载此类型图片": "การดาวน์โหลดภาพประเภทนี้ยังไม่ได้รับการสนับสนุนในขณะนี้",
}

export default Component;